/**
 * @generated SignedSource<<6903e0a0388b148a16b48e9cc1bb1f08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingStatus = "CONFIRMED" | "DRAFT";
export type DietaryTags = "ALCOHOL_FREE" | "ALLERGY" | "ALLIUM" | "CRUSTACEAN" | "DAIRY_FREE" | "DIABETIC" | "EGGS" | "FISH" | "GARLIC" | "GLUTEN_FREE" | "HAZELNUT" | "KOSHER" | "MILK" | "MUSHROOMS" | "NIGHTSHADE" | "NUTS" | "PALEO" | "PEANUTS" | "PESCATARIAN" | "PORK" | "POULTRY" | "PREGNANT" | "RED_MEAT" | "SALT" | "SEAFOOD" | "SHELLFISH" | "SHRIMP" | "SOY" | "SULFITES" | "TOMATOES" | "TREE_NUTS" | "VEGAN" | "VEGETARIAN" | "WALNUTS" | "WHEAT";
export type OccasionTags = "ANNIVERSARY" | "BIRTHDAY" | "BUSINESS_MEETING" | "CELEBRATION" | "CORPORATE_EVENT" | "GRADUATION" | "SPECIAL_EVENT";
import { FragmentRefs } from "relay-runtime";
export type DiningSpecialRequestsModal_booking$data = {
  readonly dietaryTags?: ReadonlyArray<DietaryTags> | null | undefined;
  readonly diningReservationHold?: {
    readonly id: string;
  } | null | undefined;
  readonly id: string;
  readonly notesFromMember?: string | null | undefined;
  readonly occasionTags?: ReadonlyArray<OccasionTags> | null | undefined;
  readonly startSlot?: {
    readonly agenda: {
      readonly facility: {
        readonly diningDietaryTags: ReadonlyArray<DietaryTags> | null | undefined;
        readonly diningOccasionTags: ReadonlyArray<OccasionTags> | null | undefined;
      };
    };
  } | null | undefined;
  readonly status?: BookingStatus;
  readonly " $fragmentType": "DiningSpecialRequestsModal_booking";
};
export type DiningSpecialRequestsModal_booking$key = {
  readonly " $data"?: DiningSpecialRequestsModal_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"DiningSpecialRequestsModal_booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DiningSpecialRequestsModal_booking",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dietaryTags",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "occasionTags",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notesFromMember",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DiningReservationHold",
          "kind": "LinkedField",
          "name": "diningReservationHold",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "startSlot",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Agenda",
              "kind": "LinkedField",
              "name": "agenda",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Facility",
                  "kind": "LinkedField",
                  "name": "facility",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "diningDietaryTags",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "diningOccasionTags",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "DiningBooking",
      "abstractKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "d7fa44e2fee6f2861d009c503de6cdef";

export default node;
